<div class="dialog-container">
  <div class="header-dialog">
    <h1 mat-dialog-title>Forward</h1>
  </div>
  <div mat-dialog-content>
    <p>Approving officer <span class="asterisk">*</span></p>
    <mat-form-field class="mat-form">
      <mat-label>please select an option</mat-label>
      <mat-select [(value)]="selected">
        <mat-option *ngFor="let ofc of officerList" [value]="ofc.UserName">{{ofc.DisplayName}}</mat-option>
      </mat-select>
    </mat-form-field>
    <p *ngIf="isErr" class="err-message">Please select an officer</p>
  </div>
  <div mat-dialog-actions>
    <app-button class="mar-r-10" name="Cancel" (click)="close()"></app-button>
    <app-button  name="Forward" type="flat-button" (click)="forwardToUser()"></app-button>
  </div>
</div>
